<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div
        class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 md:pb-16 rounded-b-md"
      >
        <div class="text-center relative">
          <router-link
            :to="{ name: 'ORDER' }"
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
          >
            <BackIcon />
          </router-link>
          <h2
            class="mt-5 text-sm sm:text-2xl font-semibold uppercase text-primary"
          >
            {{ $t("summary.heading") }}
          </h2>
          <h3 class="text-xs sm:text-base text-black-display mt-1 mb-6">
            {{ $t("summary.subheading") }}
          </h3>
        </div>
        <div class="flex flex-wrap items-center">
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-6 w-full text-sm sm:text-base"
          >
            <div class="flex items-center">
              <TickIcon class="mr-3 w-7 h-7 md:w-9 md:h-9" />
              <div>
                <h3
                  class="text-base sm:text-lg text-left text-primary font-semibold leading-snug"
                >
                  {{ $t("summary.chosenCategory") }}
                </h3>
              </div>
              <router-link
                class="text-salmon ml-7 hover:underline"
                :to="{ name: 'ORDER' }"
              >
                {{ $t("summary.modify") }}
              </router-link>
            </div>
            <div class="flex items-center py-4">
              <img
                v-if="chosenCategoryObj"
                class="w-20"
                :src="chosenCategoryObj.photo_url"
              >
              <p
                v-if="chosenCategoryObj"
                class="px-4"
              >
                {{ name(chosenCategoryObj) }}
              </p>
            </div>
          </div>
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-6 w-full text-sm sm:text-base"
          >
            <div class="flex items-center">
              <LayersIcon class="mr-3 w-7 h-7 md:w-9 md:h-9" />
              <div>
                <h3
                  class="text-base sm:text-lg text-left text-primary font-semibold leading-snug"
                >
                  {{ $t("summary.chosenTastes") }}
                </h3>
              </div>
              <router-link
                class="text-salmon ml-7 hover:underline"
                :to="{ name: 'ORDER' }"
              >
                {{ $t("summary.modify") }}
              </router-link>
            </div>
            <table
              v-if="tastes !== undefined && tastes.length > 0"
              class="table-fixed my-4"
            >
              <tbody>
                <tr
                  v-for="(taste, index) in tastes"
                  :key="index"
                >
                  <td class="pl-2 pr-4 py-2">
                    {{ name(getTaste(taste.taste_id)) }}
                  </td>
                  <td
                    class="pl-2 pr-4 py-2 w-1/4 whitespace-no-wrap font-semibold"
                  >
                    {{ taste.quantity }} {{ $t("summary.quantity") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-6 w-full"
          >
            <div class="flex items-center">
              <StarIcon class="mr-3 w-7 h-7 md:w-9 md:h-9" />
              <div>
                <h3
                  class="text-base sm:text-lg text-left text-primary font-semibold leading-snug"
                >
                  {{ $t("summary.chosenBonuses") }}
                </h3>
              </div>
              <router-link
                class="text-salmon ml-7 hover:underline"
                :to="{ name: 'ORDER' }"
              >
                {{ $t("summary.modify") }}
              </router-link>
            </div>
            <template v-if="extrasExist">
              <div
                v-for="(bonus, i) in bonuses"
                :key="`bonus-${i}`"
              >
                <div
                  v-if="extras[i]"
                  class="flex items-center py-4 text-sm sm:text-base"
                >
                  <img
                    class="w-20"
                    :src="bonus.photo_url"
                  >
                  <p class="px-4">
                    {{ name(bonus) }}
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="flex items-center py-4 text-sm sm:text-base">
                <p class="px-4">
                  {{ $t("summary.noExtra") }}
                </p>
              </div>
            </template>
          </div>
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-6 w-full"
          >
            <div class="flex items-center py-5">
              <PenIcon class="mr-3 w-7 h-7 md:w-9 md:h-9" />
              <div>
                <h3
                  class="text-base sm:text-lg text-left lg:w-3/4 text-primary font-semibold leading-snug"
                >
                  {{ $t("summary.infoDesc") }}
                </h3>
              </div>
            </div>
            <div class="flex flex-wrap lg:flex-no-wrap items-end">
              <div class="w-full">
                <BaseComment :key="id" />
              </div>
              <div class="lg:ml-4 lg:mr-6 file-upload">
                <FileUploader :key="id" />
              </div>
            </div>
          </div>
        </div>
        <div class="sum flex flex-col items-center">
          <h3
            class="text-primary font-semibold text-base sm:text-lg sm:text-2xl mt-8"
          >
            {{ $t("summary.estimatedPrice") }}
          </h3>
          <p
            class="text-black-display font-semibold text-3xl sm:text-4xl md:text-5xl"
          >
            {{ orderPrice }} {{ currency }}
          </p>
          <router-link
            :to="{ name: 'CONTACT_FORM' }"
            tag="button"
            class="text-xs sm:text-base btn mt-8 mb-4 mx-4 px-6 sm:px-8 md:px-12 py-4 flex items-center animate"
          >
            {{ $t("summary.submitForm") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import AccountWidget from '@/components/AccountWidget';
import FileUploader from '@/components/FileUploader';
import BaseComment from '@/components/BaseComment';
import BackIcon from '@/assets/icons/back.svg';
import TickIcon from '@/assets/icons/tick.svg';
import LayersIcon from '@/assets/icons/layers.svg';
import StarIcon from '@/assets/icons/star.svg';
import PenIcon from '@/assets/icons/pen.svg';
import name from '@/mixins/name';

export default {
  name: 'Summary',
  components: {
    AccountWidget,
    BaseComment,
    FileUploader,
    BackIcon,
    TickIcon,
    LayersIcon,
    StarIcon,
    PenIcon,
  },
  mixins: [name],
  data() {
    return {
      comment: '',
    };
  },
  computed: {
    ...mapState('order', [
      'subcategories',
      'bonuses',
      'orderPrice',
      'tastes',
      'extras',
      'subcategory_id',
      'id',
      'currency',
    ]),
    ...mapGetters('order', ['chosenCategoryObj']),
    extrasExist() {
      return Object.values(this.extras).reduce((prev, curr) => prev || curr);
    },
  },
  methods: {
    ...mapMutations('order', ['setComment']),
    getTaste(id) {
      let result;
      this.chosenCategoryObj.tastes.forEach((el) => {
        if (el.id === id) result = el;
      });

      return result;
    },
  },
};
</script>

<style lang="scss">
.file-upload {
  width: 270px;
}
</style>
